export default {
  components: {},
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  computed: {},
  watch: {
    data: {
      handler(v) {
        if (v && v.length) {
          v.forEach(item => {
            item = encodeURIComponent(item);
          });
          this.arr = v;
          this.curImage = v[0];
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      arr: [],
      curImage: ""
    };
  },
  created() {},
  methods: {
    onImageClick(item) {
      console.log("item", item);
      if (item) {
        this.curImage = item;
      }
    }
  }
};